<template>
 <div>
	<el-table :data='tableData' stripe style="width: 100%" :height="380" class="infinite-table-CAUSAL">
		<el-table-column
		type="index"
		width="50">
		</el-table-column>
		<el-table-column prop="aaChangeRefGene" label="氨基酸变异位置信息" min-width="200" >
		</el-table-column>
		<el-table-column prop="alt" label="突变reads的序列信息" min-width="155">
		</el-table-column>
		<el-table-column prop="chipId" label="芯片id" min-width="130">
		</el-table-column>
		<el-table-column prop="chr" label="染色体号" min-width="80">
		</el-table-column>
		<el-table-column prop="clinsig" label="clinsig" min-width="65">
		</el-table-column>
		<el-table-column prop="clnacc" label="clnacc" min-width="65">
		</el-table-column>
		<el-table-column prop="clndbn" label="clndbn" min-width="65">
		</el-table-column>
		<el-table-column prop="clndsdb" label="clndsdb" min-width="85">
		</el-table-column>
		<el-table-column prop="clndsdbId" label="clndsdbId" min-width="105">
		</el-table-column>
		<el-table-column prop="start" label="起始位置" min-width="100">
		</el-table-column>
		<el-table-column prop="end" label="终止位置" min-width="100">
		</el-table-column>
		<el-table-column prop="exAcAfr" label="非洲人群等位基因频率" min-width="160">
		</el-table-column>
		<el-table-column prop="exAcAll" label="总人群等位基因频率" min-width="165">
		</el-table-column>
		<el-table-column prop="exAcAmr" label="美洲人群等位基因频率" min-width="160">
		</el-table-column>
		<el-table-column prop="exAcEas" label="亚洲人群等位基因频率" min-width="160">
		</el-table-column>
		<el-table-column prop="exAcFin" label="芬兰人群等位基因频率" min-width="160">
		</el-table-column>
		<el-table-column prop="exAcNfe" label="非芬兰人的欧洲人频率" min-width="165">
		</el-table-column>
		<el-table-column prop="exAcOth" label="exAcOth" min-width="110">
		</el-table-column>
		<el-table-column prop="exAcSas" label="南亚人群频率" min-width="110">
		</el-table-column>
		<el-table-column prop="exonicFuncRefGene" label="外显功能区域" min-width="110">
		</el-table-column>
		<el-table-column prop="funcRefGene" label="功能区域" min-width="110">
		</el-table-column>
		<el-table-column prop="geneDetailRefGene" label="详细参考基因" min-width="110">
		</el-table-column>
		<el-table-column prop="geneRefGene" label="参考基因" min-width="110">
		</el-table-column>
		<el-table-column prop="normalAllele" label="正常等位基因" min-width="110">
		</el-table-column>
		<el-table-column prop="ref" label="参考基因型" min-width="110">
		</el-table-column>
		<template slot="append">
				<slot/>
		</template>
	</el-table>
</div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style>

</style>
